export default __webpack_public_path__ + "static/media/process_66.e0a26d99.svg";